interface ContentOption {
  id: string;
  label: string;
  icon: string;
  description: string;
}

const OPTIONS: ContentOption[] = [
  { id: 'image', label: 'Ad Image', icon: 'ri-image-2-line', description: 'The main visual creative' },
  { id: 'video', label: 'Animated Video', icon: 'ri-video-line', description: 'MP4 with motion effects' },
  { id: 'headline', label: 'Headline', icon: 'ri-text-wrap', description: 'Primary ad headline' },
  { id: 'primary_text', label: 'Primary Text', icon: 'ri-align-left', description: 'Main body copy' },
  { id: 'subheadline', label: 'Subheadline', icon: 'ri-text', description: 'Supporting headline' },
  { id: 'cta', label: 'CTA Button Text', icon: 'ri-cursor-line', description: 'Call to action copy' },
  { id: 'caption', label: 'Caption Copy', icon: 'ri-chat-quote-line', description: 'Post caption text' },
  { id: 'hashtags', label: 'Hashtags', icon: 'ri-hashtag', description: 'Platform hashtag set' },
  { id: 'brand', label: 'Brand Assets', icon: 'ri-building-line', description: 'Logo, colors, fonts' },
];

interface IncludedContentProps {
  selected: string[];
  onChange: (content: string[]) => void;
}

export default function IncludedContent({ selected, onChange }: IncludedContentProps) {
  const toggle = (id: string) => {
    onChange(selected.includes(id) ? selected.filter((c) => c !== id) : [...selected, id]);
  };

  const allSelected = selected.length === OPTIONS.length;
  const toggleAll = () => onChange(allSelected ? [] : OPTIONS.map((o) => o.id));

  return (
    <div className="bg-stone-900 border border-stone-800 rounded-xl p-5 mb-4">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-sm font-semibold text-white">Include in Export</h3>
        <button
          onClick={toggleAll}
          className="text-xs text-orange-400 hover:text-orange-300 transition-colors cursor-pointer whitespace-nowrap"
        >
          {allSelected ? 'Deselect All' : 'Select All'}
        </button>
      </div>
      <div className="grid grid-cols-1 gap-1.5">
        {OPTIONS.map((opt) => {
          const isActive = selected.includes(opt.id);
          return (
            <button
              key={opt.id}
              onClick={() => toggle(opt.id)}
              className={`flex items-center gap-3 px-3 py-2.5 rounded-lg border text-left transition-all duration-200 cursor-pointer ${
                isActive
                  ? 'bg-orange-500/8 border-orange-500/40'
                  : 'bg-stone-800/30 border-stone-800 hover:border-stone-700'
              }`}
            >
              <div className={`w-4 h-4 flex items-center justify-center rounded border shrink-0 ${
                isActive ? 'bg-orange-500 border-orange-500' : 'border-stone-600'
              }`}>
                {isActive && <i className="ri-check-line text-white text-xs" />}
              </div>
              <div className="w-5 h-5 flex items-center justify-center shrink-0">
                <i className={`${opt.icon} text-sm ${isActive ? 'text-orange-400' : 'text-stone-500'}`} />
              </div>
              <div className="flex-1 min-w-0">
                <span className={`text-xs font-medium ${isActive ? 'text-white' : 'text-stone-400'}`}>{opt.label}</span>
              </div>
              <span className="text-xs text-stone-600 truncate max-w-[120px] hidden sm:block">{opt.description}</span>
            </button>
          );
        })}
      </div>
      <div className="mt-3 flex items-center gap-1.5">
        <div className="w-4 h-4 flex items-center justify-center">
          <i className="ri-file-list-3-line text-stone-500 text-xs" />
        </div>
        <span className="text-xs text-stone-500">
          <span className="text-stone-300 font-medium">{selected.length}</span> of {OPTIONS.length} items included
        </span>
      </div>
    </div>
  );
}
